import { backEndAPIUrl } from 'constants/values';
import { normalizeModels } from './normalizers';

export const adjustSeries = response => {
  const wrappedResponse = {};
  const wrappedModels = [...response.models];
  wrappedModels.forEach(model => {
    model.seriesId = model.bodyStyleId;
    model.bodyStyleId = '1';
  });
  wrappedResponse.models = wrappedModels;
  return wrappedResponse;
};

export const adjustTemplatesForMini = response => {
  const seriesAdjustedResponse = { ...response };
  seriesAdjustedResponse.entities.templates &&
    Object.values(seriesAdjustedResponse.entities.templates).forEach(
      t =>
      (t.seriesId =
        seriesAdjustedResponse.entities.models[t.modelId].seriesId),
    );
  return seriesAdjustedResponse;
};

export const getTotalCartQuantity = async () => {
  const url = `${backEndAPIUrl}/cart/total-cart-quantity`;
  const accessToken = sessionStorage.getItem('access_token') || '';
  const idToken = sessionStorage.getItem('id_token') || '';
  let userId = '';

  try {
    const userInfo = JSON.parse(sessionStorage.getItem('user_info') || '{}');
    userId = userInfo?.bmwdcsnetuid || '';
  } catch (e) {
    sessionStorage.setItem('Failed to parse user_info from sessionStorage:', e);
  }

  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'x-id-token': idToken,
      'x-user-id': userId,
    },
  });

  let responseBody;
  if (response.ok) {
    responseBody = await response.json();
    return responseBody;
  } else if (response.status === 422) {
    await response.json();
  }
};

export const getCart = async ({ payload }) => {
  const sids = payload.seriesIds.join(',');
  const size = payload.seriesPageSize || 2;
  const url = `${backEndAPIUrl}/cart?seriesIds=${sids}&seriesPageSize=${size}`;
  const accessToken = sessionStorage.getItem('access_token') || '';
  const idToken = sessionStorage.getItem('id_token') || '';
  let userId = '';

  try {
    const userInfo = JSON.parse(sessionStorage.getItem('user_info') || '{}');
    userId = userInfo?.bmwdcsnetuid || '';
  } catch (e) {
    sessionStorage.setItem('Failed to parse user_info from sessionStorage:', e);
  }

  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'x-id-token': idToken,
      'x-user-id': userId,
    },
  });

  let responseBody;

  if (response.ok) {
    responseBody = await response.json();
    if (responseBody.brand === 'MI') {
      let adjustedResponse = adjustSeries(responseBody);
      let adjustedForMini = adjustTemplatesForMini(
        normalizeModels(adjustedResponse),
      );
      return adjustedForMini;
    } else {
      return normalizeModels(responseBody);
    }
  } else if (response.status === 422) {
    await response.json();
  }
};

export const submitCartTemplates = async ({ payload }) => {
  const url = `${backEndAPIUrl}/cart`;
  const accessToken = sessionStorage.getItem('access_token') || '';
  const idToken = sessionStorage.getItem('id_token') || '';
  let userId = '';

  try {
    const userInfo = JSON.parse(sessionStorage.getItem('user_info') || '{}');
    userId = userInfo?.bmwdcsnetuid || '';
  } catch (e) {
    sessionStorage.setItem('Failed to parse user_info from sessionStorage:', e);
  }

  const response = await fetch(url, {
    method: 'PATCH',
    headers: new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
      'x-id-token': idToken,
      'x-user-id': userId,
    }),
    body: JSON.stringify(payload),
    credentials: 'include',
    cache: 'no-cache',
  });

  if (response.ok) {
    return;
  } else {
    const error = new Error(response.statusText);
    throw error;
  }
};
